const translation: Record<string, string> = {
  // ========== NAVBAR ==========
  "navbar.home": "Ana Sayfa",
  "navbar.services": "Hizmetler",
  "navbar.about": "Hakkımızda",
  "navbar.projects": "Projeler",
  "navbar.contact": "İletişim",
  "navbar.products": "Ürünler",

  // ========== FOOTER ==========
  "footer.corporate": "Kurumsal",
  "footer.aboutUs": "Hakkımızda",
  "footer.ourTeam": "Ekibimiz",
  "footer.careers": "Kariyer",
  "footer.press": "Basın",
  "footer.pages": "Sayfalar",
  "footer.homePage": "Ana Sayfa",
  "footer.projects": "Projeler",
  "footer.contact": "İletişim",
  "footer.contactInfo": "İletişim",
  "footer.address": "Perpa Ticaret Merkezi, Şişli / İstanbul / Türkiye",
  "footer.phone": "+90 212 220 52 56",
  "footer.email": "info@okayisu.com",
  "footer.tagline": "LED aydınlatma proje tasarımı ve uygulamalarında güvenilir çözüm ortağınız.",
  "footer.rights": "© 2026 OKAYISU Aydınlatma San. İç ve Dış Tic. Ltd. Şti. Tüm hakları saklıdır.",
  "footer.privacyPolicy": "Gizlilik Politikası",
  "footer.termsOfUse": "Kullanım Koşulları",
  "footer.ctaTitle": "Projenizi Birlikte",
  "footer.ctaAccent": "Hayata Geçirelim",
  "footer.ctaSubtitle": "Ücretsiz keşif ve teklif için hemen iletişime geçin.",
  "footer.ctaButton": "Hemen İletişime Geçin",

  // ========== GENERAL ==========
  "general.viewAll": "Tümünü Gör",
  "general.backToProjects": "Projelere Dön",
  "general.backToList": "Projeler Listesine Dön",
  "general.loading": "Yükleniyor...",
  "general.submit": "Gönder",
  "general.close": "Kapat",
  "general.search": "Ara...",
  "general.noResults": "Aramanızla eşleşen sonuç bulunamadı.",
  "general.all": "Tümü",
  "general.scroll": "Scroll",

  // ========== STATS ==========
  "stats.yearsExperience": "Yıllık Deneyim",
  "stats.yearsExpShort": "Yıl Deneyim",
  "stats.completedProjects": "Tamamlanan Proje",
  "stats.countries": "Ülke",
  "stats.customerSatisfaction": "Müşteri Memnuniyeti",
  "stats.countriesService": "Ülkede Hizmet",

  // ========== HERO ==========
  "hero.badge": "LED Aydınlatma Uzmanları",
  "hero.slide1.badge": "İstanbul Finans Merkezi",
  "hero.slide1.year": "2019",
  "hero.slide2.badge": "Vadi İstanbul AVM",
  "hero.slide2.year": "2015",
  "hero.slide3.badge": "Kayseri Kadir Has Stadyumu",
  "hero.slide3.year": "2018",
  "hero.slide1.title": "Kurumsal Müşterilerin",
  "hero.slide1.accent": "Güvenilir İş Ortağı",
  "hero.slide1.subtitle": "Yenilikçi LED teknolojisi ile maliyetlerinizi düşürün, görsel etkiyi artırın",
  "hero.slide2.title": "Ticari Alanlarda",
  "hero.slide2.accent": "Yüksek Verimlilik",
  "hero.slide2.subtitle": "Tasarımdan uygulamaya kadar tam hizmet — anahtar teslim LED projeleri",
  "hero.slide3.title": "Sahaların",
  "hero.slide3.accent": "Parlayan Işığı",
  "hero.slide3.subtitle": "Saha aydınlatması ve tribün LED uygulamalarıyla stadyum deneyimini zirveye taşıyoruz",
  "hero.viewProjects": "Projelerimizi İnceleyin",
  "hero.getQuote": "Teklif Alın",

  // ========== ABOUT ==========
  "about.badge": "Hakkımızda",
  "about.heading1": "Hayallerinizi",
  "about.heading2": "Işığa Dönüştürüyoruz",
  "about.paragraph1": "OKAYISU, LED aydınlatma proje tasarımı ve uygulamaları alanında faaliyet gösteren köklü bir firmadır. Aydınlatma konusundaki tüm bilgi birikimimizi ve uzman ekibimizi kullanarak; hem görsel estetiği hem de teknik verimliliği en üst seviyeye taşıyacak şekilde müşterilerimizin hayallerini gerçeğe dönüştürüyoruz.",
  "about.paragraph2": "Deneyimli uzman ekibimiz sayesinde özgün tasarımlar ortaya koyuyor ve yüksek kaliteli ürünler ile projeler üretiyoruz. Kurulduğumuz günden bu yana LED aydınlatma alanındaki başarılarımızla sektörde güvenilir bir yer edinmişizdir.",
  "about.strength1": "Deneyimli mühendis ve tasarımcı ekibi",
  "about.strength2": "Uluslararası kalite standartları",
  "about.strength3": "Anahtar teslim proje yönetimi",
  "about.strength4": "Enerji verimliliği odaklı çözümler",
  "about.strength5": "Güçlü marka ve ürün portföyü",
  "about.workWithUs": "Bizimle Çalışın",
  "about.certificates": "Sertifikalar ve Belgelerimiz",
  "about.certificatesDesc": "Uluslararası standartlara uygun kalite belgelerimiz",

  // ========== SERVICES ==========
  "services.badge": "Hizmetlerimiz",
  "services.heading1": "Işık Konusunda Her Şey",
  "services.heading2": "Tek Çatı Altında",
  "services.desc": "LED aydınlatma alanındaki geniş portföyümüz ile her sektörden kurumsal müşterimize özel çözümler üretiyoruz.",
  "services.moreInfo": "Daha Fazla",
  "services.bannerTitle": "Projeniz için ücretsiz ön değerlendirme yapıyoruz.",
  "services.bannerSubtitle": "Uzman ekibimiz, ihtiyaçlarınızı yerinde değerlendirerek size en uygun çözümü sunar.",
  "services.viewProducts": "Ürünlerimizi İnceleyin",
  "services.svc1.title": "LED Proje Tasarımı",
  "services.svc1.desc": "Mekanınıza özel, estetik ve teknik açıdan mükemmel aydınlatma projeleri hazırlıyoruz. Her detay titizlikle planlanır.",
  "services.svc2.title": "Mimari Aydınlatma",
  "services.svc2.desc": "Binaların dış cephesinden iç mekânlarına kadar mimariye uyumlu, etkileyici aydınlatma çözümleri sunuyoruz.",
  "services.svc3.title": "Enerji Optimizasyonu",
  "services.svc3.desc": "Mevcut aydınlatma sistemlerinizi LED'e dönüştürerek %70'e varan enerji tasarrufu sağlıyoruz.",
  "services.svc4.title": "Anahtar Teslim Uygulama",
  "services.svc4.desc": "Tasarımdan kuruluma, testlerden bakıma kadar tüm süreci ekibimiz yönetir. Siz sadece sonucu görürsünüz.",
  "services.svc5.title": "Yurt İçi & Yurt Dışı Projeler",
  "services.svc5.desc": "Türkiye genelinde ve uluslararası arenada büyük ölçekli LED aydınlatma projeleri gerçekleştiriyoruz.",
  "services.svc6.title": "Teknik Destek & Bakım",
  "services.svc6.desc": "Projelerin tamamlanmasının ardından kesintisiz teknik destek ve periyodik bakım hizmetleri sunuyoruz.",

  // ========== BRANDS ==========
  "brands.badge": "Markalar",
  "brands.heading": "Çalıştığımız Markalar",
  "brands.headingAccent": "Markalar",

  // ========== HOME PROJECTS ==========
  "homeProjects.badge": "Referans Projeler",
  "homeProjects.heading1": "Gerçekleştirdiğimiz",
  "homeProjects.heading2": "Projelerden Seçmeler",
  "homeProjects.desc": "Yıllar içinde Türkiye ve dünya genelinde onlarca kurumsal LED aydınlatma projesini başarıyla tamamladık.",
  "homeProjects.viewAll": "Tüm Projeleri Gör",
  "homeProjects.contactUs": "Projeniz İçin Bize Ulaşın",

  // ========== CONTACT ==========
  "contact.badge": "İletişim",
  "contact.heading1": "Projeniz İçin",
  "contact.heading2": "Hemen İletişime Geçin",
  "contact.desc": "LED aydınlatma projeniz için uzman ekibimizden ücretsiz ön değerlendirme ve teklif alın. Her ölçekte projeye çözüm üretiyoruz.",
  "contact.addressLabel": "Adres",
  "contact.addressValue": "Perpa Ticaret Merkezi A Blok Kat:5 No:204, Şişli / İstanbul / Türkiye",
  "contact.phoneLabel": "Telefon",
  "contact.emailLabel": "E-posta",
  "contact.hoursLabel": "Çalışma Saatleri",
  "contact.hoursValue": "Pzt–Cum: 09:00 – 18:00",
  "contact.formTitle": "Ücretsiz Teklif İste",
  "contact.fullName": "Ad Soyad *",
  "contact.fullNamePlaceholder": "Adınız Soyadınız",
  "contact.company": "Firma *",
  "contact.companyPlaceholder": "Firma Adı",
  "contact.email": "E-posta *",
  "contact.emailPlaceholder": "ornek@firma.com",
  "contact.phone": "Telefon",
  "contact.phonePlaceholder": "+90 5xx xxx xx xx",
  "contact.serviceType": "Hizmet Türü",
  "contact.serviceTypePlaceholder": "Seçiniz...",
  "contact.serviceOption1": "Mimari Aydınlatma",
  "contact.serviceOption2": "Endüstriyel Aydınlatma",
  "contact.serviceOption3": "Dış Cephe Aydınlatma",
  "contact.serviceOption4": "İç Mekan Aydınlatma",
  "contact.serviceOption5": "Enerji Dönüşüm Projesi",
  "contact.message": "Mesajınız *",
  "contact.messagePlaceholder": "Projeniz hakkında kısaca bilgi veriniz...",
  "contact.submitBtn": "Teklif Talep Et",
  "contact.sending": "Gönderiliyor...",
  "contact.successTitle": "Mesajınız Alındı!",
  "contact.successMsg": "En kısa sürede ekibimiz sizinle iletişime geçecektir. Teşekkür ederiz.",

  // ========== PROJECTS PAGE ==========
  "projects.hero.breadcrumb": "Projeler",
  "projects.hero.badge": "Tüm Projeler",
  "projects.hero.heading1": "Gerçekleştirdiğimiz",
  "projects.hero.heading2": "LED Projelerimiz",
  "projects.hero.desc": "Türkiye ve dünya genelinde tamamladığımız kurumsal LED aydınlatma projelerinin tamamını bu sayfada bulabilirsiniz.",
  "projects.grid.searchPlaceholder": "Proje veya müşteri ara...",
  "projects.grid.count": "{count} proje listeleniyor",
  "projects.grid.noResults": "Aramanızla eşleşen proje bulunamadı.",
  "projects.cta.badge": "Projeniz Hazır mı?",
  "projects.cta.heading1": "Bir Sonraki Projeniz İçin",
  "projects.cta.heading2": "Yanınızdayız",
  "projects.cta.desc": "LED aydınlatma projenizi birlikte planlayalım. Ücretsiz keşif ve teklif için bizimle iletişime geçin.",
  "projects.cta.getQuote": "Teklif Alın",
  "projects.cta.homePage": "Ana Sayfa",
  "projects.categories.Tümü": "Tümü",
  "projects.categories.Otel & Konaklama": "Otel & Konaklama",
  "projects.categories.Ticari & AVM": "Ticari & AVM",
  "projects.categories.Altyapı & Ulaşım": "Altyapı & Ulaşım",
  "projects.categories.Spor & Eğlence": "Spor & Eğlence",
  "projects.categories.Konut & Rezidans": "Konut & Rezidans",
  "projects.categories.Kamu & Kültürel": "Kamu & Kültürel",
  "projects.categories.Endüstriyel & Kurumsal": "Endüstriyel & Kurumsal",
  "projects.categories.Kurumsal & Ticari": "Kurumsal & Ticari",

  // ========== PROJECT DETAIL ==========
  "projectDetail.breadcrumb": "Projeler",
  "projectDetail.backToProjects": "Projelere Dön",
  "projectDetail.aboutProject": "Proje Hakkında",
  "projectDetail.projectSummary": "Proje Özeti",
  "projectDetail.category": "Kategori",
  "projectDetail.year": "Yıl",
  "projectDetail.client": "Müşteri",
  "projectDetail.location": "Lokasyon",
  "projectDetail.gallery": "Proje Galerisi",
  "projectDetail.galleryEmpty": "Proje görselleri ve videoları yakında eklenecektir.",
  "projectDetail.galleryEmptyDesc": "Detaylı bilgiler için lütfen daha sonra tekrar ziyaret edin.",
  "projectDetail.backToList": "Projeler Listesine Dön",
  "projectDetail.contactForProject": "Proje İçin Bize Ulaşın",

  // ========== PRODUCTS PAGE ==========
  "products.hero.badge": "Ürün Kataloğu",
  "products.hero.heading1": "LED Aydınlatma",
  "products.hero.heading2": "Ürünlerimiz",
  "products.hero.desc": "Profesyonel LED armatürler, akıllı kontrol sistemleri ve mimari aydınlatma çözümleri — tamamı üstün kalite garantisiyle.",
  "products.grid.searchPlaceholder": "Ürün ara...",
  "products.grid.count": "{count} ürün listeleniyor",
  "products.grid.noResults": "Aramanıza uygun ürün bulunamadı.",
  "products.cta.badge": "Teknik Destek",
  "products.cta.heading1": "Hangi ürünün size uygun olduğundan",
  "products.cta.heading2": "emin değil misiniz?",
  "products.cta.desc": "Uzman ekibimiz projenizi değerlendirerek en uygun ürün ve çözümleri sizin için belirler. Ücretsiz teknik danışmanlık alın.",
  "products.cta.talkToExpert": "Uzmanla Konuş",
  "products.card.detail": "Ürün Detayı",
  "products.card.requestQuote": "Teklif İste",
  "products.card.close": "Kapat",
  "products.card.features": "Özellikler",
  "products.card.specs.power": "Güç",
  "products.card.specs.colorTemp": "Renk Sıcaklığı",
  "products.card.specs.ipRating": "IP Rating",
  "products.categories.Tümü": "Tümü",
  "products.categories.Dış Cephe Armatürleri": "Dış Cephe Armatürleri",
  "products.categories.İç Mekan LED": "İç Mekan LED",
  "products.categories.Endüstriyel High-Bay": "Endüstriyel High-Bay",
  "products.categories.Mimari Aydınlatma": "Mimari Aydınlatma",
  "products.categories.Akıllı LED Sistemler": "Akıllı LED Sistemler",
  "products.categories.Sokak & Yol LED": "Sokak & Yol LED",

  // ========== ABOUT PAGE ==========
  "aboutPage.breadcrumbHome": "Ana Sayfa",
  "aboutPage.breadcrumb": "Hakkımızda",
  "aboutPage.hero.badge": "Hakkımızda",
  "aboutPage.hero.title": "Işığın Peşinde",
  "aboutPage.hero.accent": "22 Yıldır",
  "aboutPage.hero.desc": "OKAYISU, 2004 yılından bu yana LED aydınlatma sektöründe proje tasarımı ve uygulama alanında hizmet vermektedir. Deneyimli kadromuz ve yenilikçi vizyonumuzla sektörün öncü firmaları arasında yer alıyoruz.",
  "aboutPage.story.badge": "Hikayemiz",
  "aboutPage.story.title": "Bir Işık Hikayesi:",
  "aboutPage.story.accent": "OKAYISU'nun Yolculuğu",
  "aboutPage.story.yearsBadge": "Yıl Deneyim",
  "aboutPage.story.p1": "OKAYISU Aydınlatma, 2004 yılında İstanbul'da LED aydınlatma teknolojileri alanında faaliyet göstermek üzere kuruldu. Kurulduğumuz günden bu yana yurt içi ve yurt dışında yüzlerce büyük ölçekli projeyi başarıyla tamamladık.",
  "aboutPage.story.p2": "Deneyimli mühendis ve teknik ekibimizle otellerden AVM'lere, endüstriyel tesislerden mimari yapılara kadar her ölçekte projeye özel çözümler üretiyoruz. Teknik bilgi birikimimiz ve sektör deneyimimizle müşterilerimizin beklentilerini aşan sonuçlar elde ediyoruz.",
  "aboutPage.story.p3": "Bugün 20'den fazla ülkede tamamlanmış projelerimiz, uluslararası kalite belgelerimiz ve %100 müşteri memnuniyeti odaklı çalışma prensibimizle sektörde güvenilir bir iş ortağı olarak konumlanmış bulunuyoruz.",
  "aboutPage.mission.title": "Misyonumuz",
  "aboutPage.mission.p": "LED aydınlatma teknolojilerini kullanarak mekanlara estetik ve fonksiyonel değer katmak; enerji verimliliği yüksek, çevre dostu ve sürdürülebilir aydınlatma çözümleri sunmak. Her projede müşteri memnuniyetini en üst düzeyde tutarak, teknik mükemmellik ve yenilikçi tasarım anlayışıyla sektöre yön vermek.",
  "aboutPage.vision.title": "Vizyonumuz",
  "aboutPage.vision.p": "LED aydınlatma sektöründe global ölçekte tanınan, teknolojik yenilikleri yakından takip eden ve sektöre yön veren lider bir marka olmak. Sürdürülebilir aydınlatma çözümleriyle daha yaşanabilir bir dünya için çalışmak ve gelecek nesillere daha aydınlık bir çevre bırakmak.",
  "aboutPage.stats.badge": "Rakamlarla",
  "aboutPage.stats.title": "Rakamlarla",
  "aboutPage.stats.accent": "OKAYISU",
  "aboutPage.values.badge": "Değerlerimiz",
  "aboutPage.values.title": "Bizi Biz Yapan",
  "aboutPage.values.accent": "Değerler",
  "aboutPage.values.v1.title": "Yenilikçilik",
  "aboutPage.values.v1.desc": "En son LED teknolojilerini yakından takip eder, projelerimize sürekli yenilik katarız.",
  "aboutPage.values.v2.title": "Kalite",
  "aboutPage.values.v2.desc": "Uluslararası standartlarda kalite anlayışıyla her projede mükemmelliği hedefleriz.",
  "aboutPage.values.v3.title": "Uzman Ekip",
  "aboutPage.values.v3.desc": "Deneyimli mühendis ve tasarımcı kadromuzla her projeye özel çözüm geliştiririz.",
  "aboutPage.values.v4.title": "Sürdürülebilirlik",
  "aboutPage.values.v4.desc": "Enerji verimliliği odaklı çözümlerle çevreye ve ekonomiye katkı sağlarız.",
  "aboutPage.values.v5.title": "Küresel Vizyon",
  "aboutPage.values.v5.desc": "20'den fazla ülkede tamamlanmış projelerle uluslararası deneyime sahibiz.",
  "aboutPage.values.v6.title": "Güvenilirlik",
  "aboutPage.values.v6.desc": "Şeffaf iş süreçleri ve zamanında teslimatla müşterilerimizin güvenini kazanırız.",
  "aboutPage.certificates.badge": "Belgelerimiz",
  "aboutPage.certificates.title": "Sertifikalar ve Belgelerimiz",
  "aboutPage.certificates.desc": "Uluslararası standartlara uygun kalite belgelerimizle güvenle hizmet veriyoruz.",
  "aboutPage.cta.badge": "Projeniz Hazır mı?",
  "aboutPage.cta.title": "Sıradaki Projeniz İçin",
  "aboutPage.cta.accent": "Yanınızdayız",
  "aboutPage.cta.desc": "LED aydınlatma projenizi birlikte planlayalım. Ücretsiz keşif ve teklif için bizimle iletişime geçin.",
  "aboutPage.cta.btn": "Teklif Alın",

  // ========== CONTACT PAGE ==========
  "contactPage.breadcrumbHome": "Ana Sayfa",
  "contactPage.breadcrumb": "İletişim",
  "contactPage.hero.badge": "İletişim",
  "contactPage.hero.title": "Bizimle",
  "contactPage.hero.accent": "İletişime Geçin",
  "contactPage.hero.desc": "LED aydınlatma projeniz için uzman ekibimizden ücretsiz ön değerlendirme ve teklif alın. Size en kısa sürede dönüş yapalım.",
  "contactPage.info.badge": "Bize Ulaşın",
  "contactPage.info.title": "İletişim",
  "contactPage.info.accent": "Bilgilerimiz",
  "contactPage.info.desc": "Aşağıdaki kanallardan bize ulaşabilir veya formu doldurarak teklif talep edebilirsiniz.",
};

export default translation;